<!--
 * @Author: M.D.
 * @Date: 2019-12-23 14:25:25
 * @LastEditors  : M.D.
 * @Description: 我的订单
 * @Remarks:
 -->
<template>
  <div class="my-order bShadow-5">
    <el-tabs @tab-click="tabClick" v-model="curTabName" class="ui-tabs ui-custom-s">
      <el-tab-pane name="0" class="my-msg">
        <span slot="label" class="lb-txt">全部</span>
        <ui-order-list v-if="queryParam.type == '0'" @orderUpdate="orderUpdate" :orderList="allOrders"></ui-order-list>
      </el-tab-pane>
      <el-tab-pane name="1" class="or-inf">
        <span slot="label" class="lb-txt">待确认({{orderNum.waitForConfirm}})</span>
        <ui-order-list v-if="queryParam.type == '1'" @orderUpdate="orderUpdate" :orderList="allOrders"></ui-order-list>
      </el-tab-pane>
      <el-tab-pane name="2" class="or-inf">
        <span slot="label" class="lb-txt">待付款({{orderNum.waitForPay}})</span>
        <ui-order-list v-if="queryParam.type == '2'" @orderUpdate="orderUpdate" :orderList="allOrders"></ui-order-list>
      </el-tab-pane>
      <el-tab-pane name="3" class="or-inf">
        <span slot="label" class="lb-txt">进行中({{orderNum.being}})</span>
        <ui-order-list v-if="queryParam.type == '3'" @orderUpdate="orderUpdate" :orderList="allOrders"></ui-order-list>
      </el-tab-pane>
      <el-tab-pane name="4" class="or-inf">
        <span slot="label" class="lb-txt">待评价({{orderNum.waitForEvaluate}})</span>
        <ui-order-list v-if="queryParam.type == '4'" @orderUpdate="orderUpdate" :orderList="allOrders"></ui-order-list>
      </el-tab-pane>
      <el-tab-pane name="5" class="or-inf">
        <span slot="label" class="lb-txt">已完成({{orderNum.complete}})</span>
        <ui-order-list v-if="queryParam.type == '5'" @orderUpdate="orderUpdate" :orderList="allOrders"></ui-order-list>
      </el-tab-pane>
    </el-tabs>
    <div class="order-pagination-w">
      <el-pagination
        background
        v-if="paginationValue.total > 0"
        layout="prev, pager, next"
        :page-size="queryParam.pageSize"
        :current-page="queryParam.currentPage"
        @current-change="pageChange"
        :total="paginationValue.total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import UiOrderList from '@/components/ui-order-list'
import API from '@/api/ord-api'
import { mapGetters } from 'vuex'

export default {
  props: {},
  data () {
    return {
      queryParam: {
        currentPage: 1,
        pageSize: 4,
        type: 0,
        memberId: ''
      },
      paginationValue: {
        total: 0
      },
      orderNum: {},
      curTabName: '0',
      allOrders: []
    }
  },
  computed: {
    ...mapGetters(['userInfo'])
  },
  created () {
  },
  mounted () {
    this.queryParam.memberId = this.userInfo.id
    this.getMyOrderNumber()
    this.getOrderList()
  },
  activated () {
    this.orderUpdate()
  },
  deactivated () {

  },
  watch: {},
  methods: {
    tabClick (option) {
      this.queryParam.type = option.name
      this.queryParam.currentPage = 1
      this.getOrderList()
    },
    orderUpdate () {
      // this.queryParam.currentPage = 1
      this.getMyOrderNumber()
      this.getOrderList()
    },
    pageChange (currentPage) {
      this.queryParam.currentPage = currentPage
      this.getOrderList()
    },
    async getOrderList () {
      const re = await API.getOrderList(this.queryParam)
      this.paginationValue.total = parseInt(re.data.result.total)
      this.allOrders = re.data.result.records
    },
    async getMyOrderNumber () {
      const re = await API.getMyOrderNumber({})
      this.orderNum = re.data.result
      console.log(re.data.result)
    }
  },
  components: {
    UiOrderList
  }
}
</script>

<style lang="stylus">
  .my-order
    min-height 580px
    box-sizing border-box
    background-color #ffffff
    position relative

    .ui-goods-list
      box-sizing border-box
      padding 0px 20px

    .order-pagination-w
      position absolute
      right 30px
      bottom 40px
</style>
